import styled from "@emotion/styled";
import { color } from "metabase/lib/colors";
export const TablesDivider = styled.span`
  color: ${color("text-light")};
  font-size: 1em;
  font-weight: bold;
  padding: 0 0.2em;
  user-select: none;
`;
